export default {
    'UsedTime': 'Used time:{time}',
    'FlowTrack': 'Workflow track',
    'Participant': 'Current Approver',
    'Participants': 'Current Approvers:',
    'FinishNode': 'Ended Activities',
    'ProcessNode': 'Processing Activities',
    'WrongNode': 'Unusual Activity',
    'UnstartNode': 'Unstarted Activity',
    'Person': '{length} person',
    'chartTips': 'Flowchart can be resized by gesture',
    'trust': '【{name} entrust】',
    'WorkflowActionStatus': {
        'Submit': 'Submit',
        'Submits': 'Submit',
        'Cancel': 'Cancel',
        'Agree': 'Agree',
        'DisAgree': 'Disagree',
        'AdjustParticipant': 'Add-approver',
        'ActivateActivity': 'Activate Other Nodes',
        'ADJUST_PARTICIPANT': 'Adjust Current Processor',
        'CANCELED_ACTIVITY_WORKITEM': 'Cancel All Tasks Of The Node',
        'MODIFY_OWNER': 'Modify Owner',
        'Assist': 'Assist',
        'Forward': 'Transfer',
        'Reject': 'Reject',
        'FinishInstance': 'End-workflow',
        'UnRead': 'Unread',
        'Read': 'Read',
        'Circularize': 'Circularize',
        'Empty': '',
        'Revoke': 'Revoke',
        'BeCanceled': 'Be Canceled',
        'AutoCanceled': 'Auto Cancel',
    },
    'WorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Draft': 'Draft',
        'BeCanceled': 'Be Canceled',
    },
};
